import React from "react";
import { FormikProps } from "formik";
import { TextField } from "@material-ui/core";
import { observer } from "mobx-react";
import { observable } from "mobx";
import OutsideClickHandler from "react-outside-click-handler";
import { STWrapper, STColorShape, STPicker } from "./styles";

interface IProps<T> {
  fieldName: string;
  label: string;
  formikProps: FormikProps<T>;
}

@observer
export default class ColorField<T> extends React.Component<IProps<T>> {
  @observable color: string = "";
  @observable isOpened: boolean = false;

  handlePickerOpen = () => {
    this.isOpened = true;
  };

  handlePickerClose = () => {
    this.isOpened = false;
  };

  handleColorChange = (e: any) => {
    this.color = e.hex;
    this.props.formikProps.setFieldValue(this.props.fieldName as string, this.color);
  };

  componentDidMount() {
    const fieldNames = this.props.fieldName.split(".");
    const hexColor =
      fieldNames.length > 1
        ? this.props.formikProps.values[fieldNames[0]][fieldNames[1]]
        : this.props.formikProps.values[this.props.fieldName];
    this.handleColorChange({
      hex: hexColor,
    });
  }

  render() {
    return (
      <STWrapper>
        <STColorShape color={this.color} />
        <TextField
          value={this.color}
          onClick={this.handlePickerOpen}
          label={this.props.label}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          error={
            this.props.formikProps.touched[this.props.fieldName] &&
            !!this.props.formikProps.errors[this.props.fieldName]
          }
          helperText={
            this.props.formikProps.touched[this.props.fieldName] && this.props.formikProps.errors[this.props.fieldName]
          }
        />
        {this.isOpened && (
          <OutsideClickHandler onOutsideClick={this.handlePickerClose}>
            <STPicker color={this.color} onChange={this.handleColorChange} />
          </OutsideClickHandler>
        )}
      </STWrapper>
    );
  }
}
